var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWishlistNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 48,
    viewBox: "0 0 95 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.75,
    height: 48,
    transform: "translate(0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0667 14.6666C55.765 14.6666 58.25 18.1433 58.25 21.3866C58.25 27.955 47.9367 33.3333 47.75 33.3333C47.5633 33.3333 37.25 27.955 37.25 21.3866C37.25 18.1433 39.735 14.6666 43.4333 14.6666C45.5567 14.6666 46.945 15.7283 47.75 16.6616C48.555 15.7283 49.9433 14.6666 52.0667 14.6666Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWishlistNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wishlistNav.2509b2aa.svg";
export { ForwardRef as ReactComponent };